import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  InstaCitiCountries,
  InstaNearByLocality,
  InstaPopularCity,
} from "../instaciti-new.interface";
import { InstacitiNewService } from "../service/instaciti-new.service";

@Component({
  selector: "portal-instaciti-banner",
  templateUrl: "./instaciti-banner.component.html",
  styleUrls: ["./instaciti-banner.component.css"],
})
export class InstacitiBannerComponent implements OnInit {
  countries: InstaCitiCountries[] = [];
  selectedKeyWord = { Keywd: "" };
  cities = [];
  popularCities: InstaPopularCity[] = [];
  selectedCountry;
  locationDetected: boolean = false;
  nearby: InstaNearByLocality[] = [];
  selectedCity;
  latitude: number;
  longitude: number;
  searchResult: [];
  zoom: number;
  heading: string;
  location: string;
  subHeading: string;
  searchText: string;
  bannerImgURL: string;
  @Input() business: string;
  constructor(
    private service: InstacitiNewService,
    private route: Router,
    private routeParam: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.FetchBusiness();
    this.getCountries();
    this.searchText = this.routeParam.snapshot.params["locality"]
      ? this.routeParam.snapshot.params["locality"]
      : "";
    this.location = this.searchText;
  }

  FetchBusiness() {
    switch (this.business) {
      case "restaurant":
        this.heading = "Discover the best food & drinks in Delhi NCR";
        this.subHeading =
          "Explore curated lists of top restaurants, cafes, pubs, and bars in Delhi NCR, based on trends.";
        this.bannerImgURL = "./assets/img/food.png";
        break;
      case "beauty-and-spa":
      case "beauty-spa":
        this.heading = "Discover the best Beauty & Spa in Delhi NCR";
        this.subHeading =
          "Explore curated lists of top beauty & spa businesses in Delhi NCR, based on trends.";
        this.bannerImgURL = "./assets/img/beauty-spa-hero.png";
        break;
      default:
        break;
    }
  }

  selectCountry(country) {
    this.selectedCountry = country;
    this.service.locationSubject.next(country.CountryName);
    this.service.setSelectedCountry(this.selectedCountry);
    // this.service.selectedCountrySubject.next(this.selectedCountry);
    sessionStorage.setItem("PortalDS", this.selectedCountry.CountryDBContext);
    this.service.GetCitiesOfCountry(country.CountryID).subscribe((res) => {
      this.cities = res.ManikJSon[0].JSon0;
      this.service.citiesSubject.next(this.cities);
    });
    this.service.GetPopularCities(country).subscribe((res) => {
      this.popularCities = res.ManikJSon[0].JSon0;
      this.service.popularCitiesSubject.next(this.popularCities);
    });
  }

  getCountries() {
    this.service.GetCountries().subscribe((res) => {
      this.countries = res.ManikJSon[0].JSon0;
      this.selectCountry(this.countries.find((c) => c.CountryID === 100000));
    });
  }
  selectLocation(event: any) {
    switch (event.target.value) {
      case "0":
        this.setCurrentLocation();
        break;
      case "-1":
        break;
      default:
        if (this.locationDetected) {
          this.selectedCity = this.nearby.find(
            (element) => element.CityID === parseInt(event.target.value)
          );
        } else {
          this.selectedCity = this.popularCities.find(
            (element) => element.CityID === parseInt(event.target.value)
          );
        }
        console.log(this.selectedCity);
        break;
    }
  }
  setCurrentLocation() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.locationDetected = true;
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 8;
        this.getNearBy();
      });
    }
  }
  getNearBy() {
    this.service
      .GetNearByLocalities({
        CountryID: this.selectedCountry.CountryID,
        Latitude: this.latitude ? this.latitude : this.selectedCountry.Latitude,
        Longitude: this.longitude
          ? this.longitude
          : this.selectedCountry.Longitude,
        portalds: this.selectedCountry.CountryDBContext,
        SearchText: this.searchText || "",
      })
      .subscribe((res) => {
        this.nearby = res.ManikJSon[0].JSon0.length
          ? res.ManikJSon[0].JSon0.slice(0, 20)
          : [];
      });
  }
  search(event: any) {
    const keyword = event.target.value;
    this.service
      .SearchByKeyword(
        this.selectedCity ? this.selectedCity : this.selectedCountry,
        keyword.trim()
      )
      .subscribe((res) => {
        this.searchResult = res.ManikJSon[0].JSon0.length
          ? res.ManikJSon[0].JSon0.slice(0, 50)
          : [];
      });
  }
  selectNearByCity(city) {
    this.selectedCity = city;
    this.location = city.LocName;
    this.searchText = city.LocName;
    let locn = location.pathname.replace(
      this.routeParam.snapshot.params["locality"],
      this.selectedCity.URLName.trim()
    );
    this.route.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.route.navigateByUrl(locn);
  }
  selectPopularCity(city) {
    this.selectedCity = city;
    this.location = city.CityName;
    this.searchText = city.CityName;
    let locn = location.pathname.replace(
      this.routeParam.snapshot.params["locality"],
      this.selectedCity.URLName.trim()
    );
    this.route.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.route.navigateByUrl(locn);
  }
  onChange(item) {
    this.selectedKeyWord = item;
    if (item.Tgt === "S") {
      this.route.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      };
      this.route.navigateByUrl(
        this.selectedCity.URLName.trim() + "/" + item.URL
      );
    } else if (item.Tgt === "N") {
      this.GoToBizSpot(item.URL);
    }
  }
  GoToBizSpot(url) {
    window.open(url, "_blank");
  }
}
